module.exports = __webpack_public_path__ + "img/11_2023_11_20.7691003c.png";